import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { iconSubset } from '@optima-stride-ai/optima-components';
import { IconSetService } from '@coreui/icons-angular';
import { SocketService } from './services/socket.service';
import { WopiApiProxyService } from './services/wopi-api-proxy.service';
import { environment } from '../environments/environment';
import { isXappCapEmbedMode } from '@optima-stride-ai/optima-app-framework';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.sass'
})
export class App implements OnInit {
  private iconSetService = inject(IconSetService);
  private socketService = inject(SocketService);
  private wopiApiProxyService = inject(WopiApiProxyService);
  private titleService = inject(Title);

  constructor() {
    this.iconSetService.icons = { ...iconSubset };
    this.titleService.setTitle(environment.displayName);
  }

  ngOnInit(): void {
    // Embedded PDFs/images/Markdown do not need WOPI. CollaboraService connects
    // on demand when an embedded Office document requests its editor URL.
    if (environment.collaboraEnabled && !isXappCapEmbedMode()) {
      this.socketService.connect();
      // REMOVED: Global initialization - now done per-file in CollaboraViewerComponent
      // this.wopiApiProxyService.initialize();
    }
  }
}